<template>
  <div class="calico-prompt-result">
    <CalicoPromptBubble
      :prompt="prompt"
      :attachments="attachments"
    />
    <CalicoAiError
      v-if="error"
      :error="error" 
    />
    <CalicoResult 
      v-else
      :message="reply" 
    />
  </div>
</template>
  
  <script>
  import CalicoPromptBubble from '@/components/calico/promptBubble/index.vue';
  import CalicoAiError from '@/components/calico/aiError/index.vue';
  import CalicoResult from '@/components/pattern/result/index.vue';
  
  export default {
    name: 'CalicoPromptResult',
    components: {
      CalicoPromptBubble,
      CalicoResult,
      CalicoAiError
    },
    props: {
      prompt: {
        type: String,
        required: true
      },
      attachments: {
        type: Array,
        required: true,
        default: () => ([])
      },
      reply: {
        type: String,
        required: true
      },
      error: {
        type: String,
        default: ""
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .calico-prompt-result {
    @include stack-space($space-large);
    width: 100%;
  }
  </style>